/**
 * IconField tokens - icon positioning wrapper for input fields
 *
 * Note: Border, background, and radius styling are handled by the wrapped
 * InputText component via inputtext tokens. IconField only manages icon color.
 */
export const iconfieldTokens = {
  iconfield: {
    icon: {
      color: '{formField.iconColor}'
    }
  }
};

export type IconFieldTokens = typeof iconfieldTokens;
